'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _multiSorter = require('./multi-sorter');

var _multiSorter2 = _interopRequireDefault(_multiSorter);

var _result = require('./result');

var _result2 = _interopRequireDefault(_result);

require('./cycle.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Verb represents a REST verb: GET, POST, PUT, PATCH or DELETE.

var Verb = function () {
    function Verb(method, resource, parameterValues) {
        _classCallCheck(this, Verb);

        this.method = method;

        this.resource = resource;
        this.configuration = resource.configuration;
        this.environment = resource.configuration.environment;
        this.application = this.environment.application;
        this.xmlHttpRequest = resource.configuration.xmlHttpRequest;
        this.willAcceptJWT = this.resource.willAcceptJWT;

        this.log = resource.log;

        if (this.xmlHttpRequest === undefined) {
            if (typeof XMLHttpRequest === 'undefined') {
                this.log.error();
                this.log.error('It looks like you\'re running inside a Node app. Please import');

                this.log.error('the xmlhttprequest NPM module and pass it as the fourth parameter\n' + 'to Environments.environment()');

                this.log.error();
                this.log.error('For example\n\n');
                this.log.error('  const XMLHttpRequest = require(\'xmlhttprequest\').XMLHttpRequest;\n');
                this.log.error('  const env = environment(\'local\', \'UnitTest\', undefined, XMLHttpRequest);');
                this.log.error();

                throw new Error('XMLHttpRequest is missing');
            } else {
                this.xmlHttpRequest = XMLHttpRequest;
            }
        }

        this.parameterValues = parameterValues;

        this.rawResponse = false;
        this.body = undefined;
        this.parameters = undefined;

        this.successReturn = undefined;
        this.failureReturn = undefined;

        this.profileCallDuration = resource.profileCallDuration;
        this.profileCallInitiation = resource.profileCallInitiation;

        this.url = this.buildUrl(parameterValues);

        this.cancelled = false;
        this.promise = undefined;

        this.progressCallback = undefined;

        this.needsAuthentication = resource.needsAuthentication;

        // If the resource is chatty, we'll make all requests chatty, but individual
        // Verb instances can override it by calling Verb.verbose().

        this.chatty = this.resource.chatty;

        // We also default to the same call headers specified for the resource. This
        // can be overridden by calling Verb.headers().

        this.callHeaders = this.resource.callHeaders;

        this.transformer = undefined;

        this.ordering = undefined;

        // By default, we assume there is no pagination involved, unless the user calls page()

        this.page = undefined;
        this.itemsPerPage = undefined;

        // By default, we use the same interceptors as the resource that is making requests

        this.requestInterceptors = resource.requestInterceptors.slice(0);
        this.responseInterceptors = resource.responseInterceptors.slice(0);

        // We set a timeout, to catch the case where the user forgets to call().

        this.timeout = setTimeout(timeout.bind(this, parameterValues), 100);

        function timeout(parameterValues) {
            var message = 'Resource("' + this.resource.name + '").' + this.method + '(' + parameterValues + ')' + ' - looks like you forgot to call().';

            this.log.scream(message);
        }
    }

    _createClass(Verb, [{
        key: 'addRequestInterceptor',
        value: function addRequestInterceptor(interceptor) {
            this.requestInterceptors.push(interceptor);

            return this;
        }
    }, {
        key: 'addResponseInterceptor',
        value: function addResponseInterceptor(interceptor) {
            this.responseInterceptors.push(interceptor);

            return this;
        }
    }, {
        key: 'removeRequestInterceptor',
        value: function removeRequestInterceptor(interceptor) {
            var index = this.requestInterceptors.indexOf(interceptor);

            if (index < 0) {
                var prefix = 'Environment["' + this.environment.name + '].Resource("' + this.name + '")';

                this.log.error(prefix + '.removeRequestInterceptor() - failed to find the interceptor');
            } else {
                this.requestInterceptors = this.requestInterceptors.splice(index, 1);
            }

            return this;
        }
    }, {
        key: 'removeResponseInterceptor',
        value: function removeResponseInterceptor(interceptor) {
            var index = this.responseInterceptors.indexOf(interceptor);

            if (index < 0) {
                var prefix = 'Environment["' + this.environment.name + '].Resource("' + this.name + '")';

                this.log.error(prefix + '.removeResponseInterceptor() - failed to find the interceptor');
            } else {
                this.responseInterceptors = this.responseInterceptors.splice(index, 1);
            }

            return this;
        }
    }, {
        key: 'verbose',
        value: function verbose(value) {
            if (value === undefined) {
                value = true;
            }

            this.chatty = value;

            return this;
        }
    }, {
        key: 'result',
        value: function result(initialisation) {
            // This helper function constructs a Result from an initialisation
            // object (that would contain properties like data, status, message,
            // etc.
            //
            // The Result class adds methods like firstPage() & nextPage()
            // for handling paginated responses.
            //
            // It also ensures that any interceptors are called before returning
            // the result.
            //
            // NOTE: We pass this verb as the second parameter when calling, so it
            //       doesn't need to be listed in the interceptor's signature if
            //       unused.

            var result = new _result2.default(this, initialisation);
            var updatedResult = result;

            for (var i = 0; i < this.responseInterceptors.length; i++) {
                updatedResult = this.responseInterceptors[i](updatedResult, this);

                if (updatedResult === null) {
                    this.log.error(this.callDetails() + '.result() - response interceptor ' + i + ' returned null;' + ' returning the initial response ...', result);

                    return result;
                }
            }

            return updatedResult;
        }
    }, {
        key: 'cancel',
        value: function cancel() {
            // If we've initiated an XmlHTTPRequest, it will always complete, in some way.
            //
            // We want to immediately resolve this Verb's promise with a specific result that
            // tells the caller that the request was cancelled, rather than completed.
            //
            // Also, we set cancelled to true, to ensure that when the XmlHTTPRequest does
            // complete, we ignore the response (other than potentially logging it).

            this.cancelled = true;

            if (this.promise) {
                this.promise.resolve(this.result({ cancelled: true, status: 0 }));
            }
        }
    }, {
        key: 'raw',
        value: function raw(value) {
            if (value == undefined) {
                value = true;
            }

            this.rawResponse = value;

            return this;
        }
    }, {
        key: 'firstPage',
        value: function firstPage() {
            this.page = 1;

            return this;
        }
    }, {
        key: 'page',
        value: function page(_page) {
            this.page = _page;

            return this;
        }
    }, {
        key: 'itemsPerPage',
        value: function itemsPerPage(n) {
            this.itemsPerPage = n;

            return this;
        }
    }, {
        key: 'sort',
        value: function sort(ordering) {
            this.ordering = ordering;

            return this;
        }
    }, {
        key: 'transform',
        value: function transform(transformer) {
            this.transformer = transformer;

            return this;
        }
    }, {
        key: 'withBody',
        value: function withBody(body) {
            this.body = body;

            return this;
        }
    }, {
        key: 'withParams',
        value: function withParams(parameters) {
            this.parameters = parameters;

            return this;
        }
    }, {
        key: 'headers',
        value: function headers(_headers) {
            this.callHeaders = _headers;

            return this;
        }
    }, {
        key: 'handleErrorsUsing',
        value: function handleErrorsUsing(handler) {
            this.errorHandler = handler;

            return this;
        }
    }, {
        key: 'succeedWith',
        value: function succeedWith(response) {
            this.successReturn = response;

            if (this.chatty) {
                this.log.debug('Resource("' + this.resource.name + '").' + this.method + '().succeedWith()' + ' - setting successReturn', response);
            }

            return this;
        }
    }, {
        key: 'failWith',
        value: function failWith() {
            var message = 'Resource("' + this.resource.name + '").' + this.method + '().failWith()' + ' - you need to provide either a single parameter, which is an object with' + ' "status" and "message" keys, or two parameters, one being a numeric status' + ' and the other a string message';

            if (arguments.length === 1) {
                var response = arguments[0];

                if (response['status'] && response['message']) {
                    if (this.chatty) {
                        this.log.debug('Resource("' + this.resource.name + '").' + this.method + '().failWith()' + ' - setting failureReturn', response);
                    }

                    this.failureReturn = response;

                    return this;
                }
            } else if (arguments.length === 2) {
                var type0 = _typeof(arguments[0]);
                var type1 = _typeof(arguments[1]);

                if (type0 === 'string' && type1 === 'number') {
                    this.failureReturn = this.result({ status: arguments[1], message: arguments[0] });

                    return this;
                } else if (type0 === 'number' && type1 === 'string') {
                    this.failureReturn = this.result({ status: arguments[0], message: arguments[1] });

                    return this;
                }
            }

            this.log.error(message);
        }
    }, {
        key: 'profile',
        value: function profile(value) {
            if (value === undefined) {
                value = true;
            }

            this.profileCallDuration = value;

            return this;
        }
    }, {
        key: 'profileCalls',
        value: function profileCalls(value) {
            if (value === undefined) {
                value = true;
            }

            this.profileCallInitiation = value;

            return this;
        }
    }, {
        key: 'refresh',
        value: function refresh() {
            this.resource.cachedResponses[this.cacheKey(this.parameterValues)] = undefined;
        }
    }, {
        key: 'acceptsJWT',
        value: function acceptsJWT() {
            var accepts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

            this.willAcceptJWT = accepts;

            return this;
        }
    }, {
        key: 'send',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var _this = this;

                var shortCircuit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

                var prefix, i, configuration, env, environment, superseded, route, response, key, value, message, _message, parametersToQueryString, _message2, parameters, keys, window, callHeaders, _environment, authTokenName, token, error;

                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                parametersToQueryString = function parametersToQueryString(parameters) {
                                    var keys = Object.keys(parameters);

                                    return keys.map(function (name) {
                                        var value = parameters[name];
                                        var param = void 0;

                                        if (Array.isArray(value)) {
                                            param = value.map(function (v) {
                                                return name + '=' + encodeURIComponent(v);
                                            }).join('&');
                                        } else {
                                            param = name + '=' + encodeURIComponent(value);
                                        }

                                        return param;
                                    });
                                };

                                prefix = 'Resource("' + this.resource.name + '").' + this.method + '().send()';


                                this.startTime = new Date();

                                for (i = 0; i < this.requestInterceptors.length; i++) {
                                    this.requestInterceptors[i](this);
                                }

                                clearTimeout(this.timeout);

                                configuration = this.resource.configuration;
                                env = configuration.environment;
                                environment = configuration.environment;


                                if (environment === undefined) {
                                    this.log.error('Whoops(1) - environment is undefined; let Harry know it happened again!');

                                    debugger;
                                }

                                // If we are caching responses, and we have already seen this set of
                                // parameters, return the cached value.

                                if (!(this.method === 'get')) {
                                    _context.next = 21;
                                    break;
                                }

                                // If we have mock data for this specific call, return it.  The order of priority is:
                                //
                                // 1. Data provided via succeedWith() / failWith()
                                // 2. Mock data specific to the resource
                                // 3. Mock data provided in the environment

                                superseded = this.callDetails() + '.call() - the data you provided to succeedWith()' + ' or failWith() supersedes the value in your mock data';


                                if (this.resource.mockData || this.environment.mockData) {
                                    route = this.url.replace(/^https?:\/\/[^\/]+\//, '');
                                    response = this.findMockData(route, this.resource.mockData, 'resource');


                                    if (!response) {
                                        response = this.findMockData(route, this.environment.mockData, 'env');
                                    }

                                    if (response) {
                                        if (this.successReturn || this.failureReturn) {
                                            this.log.warn(superseded);
                                        } else {
                                            this.successReturn = { data: this.sortResponse(response) };
                                        }
                                    } else {
                                        if (this.chatty) {
                                            this.log.debug(prefix + ' - failed to find "' + route + '" in any of the mock data');
                                        }
                                    }
                                }

                                if (!this.resource.cachedResponses) {
                                    _context.next = 19;
                                    break;
                                }

                                key = this.cacheKey(this.parameterValues);
                                value = this.resource.cachedResponses[key];

                                if (!value) {
                                    _context.next = 19;
                                    break;
                                }

                                if (this.profileCallDuration || this.chatty) {
                                    this.log.debug(prefix + ' - returning cached value');
                                }

                                this.logElapsedTime();

                                return _context.abrupt('return', this.result({ status: 200, data: this.sortResponse(value) }));

                            case 19:
                                _context.next = 22;
                                break;

                            case 21:
                                if (this.method !== 'delete') {
                                    if (this.body === undefined) {
                                        message = prefix + ' - you forgot to call withBody()';


                                        this.log.error(message);
                                    }
                                }

                            case 22:
                                if (!this.successReturn) {
                                    _context.next = 25;
                                    break;
                                }

                                if (this.chatty) {
                                    this.log.debug($prefix + ' - responding with successReturn of', successReturn);
                                }

                                return _context.abrupt('return', this.successReturn);

                            case 25:
                                if (!this.failureReturn) {
                                    _context.next = 28;
                                    break;
                                }

                                if (this.chatty) {
                                    this.log.debug(prefix + ' - responding with failureReturn of', this.failureReturn);
                                }

                                return _context.abrupt('return', this.failureReturn);

                            case 28:
                                if (!this.resource.needsAuthentication) {
                                    _context.next = 43;
                                    break;
                                }

                                if (this.chatty) {
                                    this.log.debug(prefix + ' - we require authentication');
                                }

                                if (!env.authToken) {
                                    _context.next = 34;
                                    break;
                                }

                                if (this.chatty) {
                                    this.log.debug(prefix + ' - we have an authToken = ' + env.authToken);
                                }
                                _context.next = 43;
                                break;

                            case 34:
                                if (this.chatty) {
                                    this.log.debug('$prefix{} - we don\'t have an authToken');
                                }

                                if (!(env.username && env.password)) {
                                    _context.next = 41;
                                    break;
                                }

                                if (this.chatty) {
                                    this.log.debug(prefix + ' - we have a username & password.  Attempting to authenticate...');
                                }

                                _context.next = 39;
                                return env.authenticate(env.username, env.password);

                            case 39:
                                _context.next = 43;
                                break;

                            case 41:
                                _message = prefix + ' -' + ' this resource requires authentication, but we have neither an' + ' authToken nor a username & password.\n' + ' If you are using a local mock REST server that doesn\'t need' + ' authentication, you can call Environment.bypassAuthentication()' + ' and no checks will be made.\n' + ' This happens automatically if you include env=local in your query' + ' string.\n' + ' If you have individual resources that do not require authentication' + ' (for example, where the resource is used to retrieve assets from the' + ' CDN), you can call Resource.bypassAuthentication() to turn it off' + ' for all verbs executed against that resource.';


                                this.log.scream(_message);

                            case 43:

                                // If a proxy has been specified, use it

                                this.callProxy = this.callProxy || configuration.callProxy || environment.callProxy;

                                _context.prev = 44;

                                if (this.chatty) {
                                    this.log.debug(prefix + ' - start of try block');
                                }

                                if (this.resource.needsAuthentication) {
                                    if (this.chatty) {
                                        this.log.debug(prefix + ' - needs authentication');
                                    }

                                    if (env) {
                                        if (env.authToken) {
                                            if (this.chatty) {
                                                this.log.debug(prefix + ' - we have an authToken = ' + env.authToken);
                                            }
                                        } else {
                                            _message2 = prefix + ' - this resource requires authentication; ' + 'please call Environment.authenticate() first.';


                                            this.log.scream(_message2);
                                        }
                                    } else {
                                        this.log.error('Whoops(2) - env is undefined; let Harry know it happened again!');
                                        debugger;
                                    }
                                }

                                parameters = [];


                                if (this.chatty) {
                                    this.log.debug(prefix + ' - checking if it\'s a GET');
                                }

                                if (this.method === 'get') {
                                    if (this.chatty) {
                                        this.log.debug(prefix + ' - it\'s a GET');
                                    }

                                    if (this.body) {
                                        if (this.chatty) {
                                            this.log.debug(prefix + ' - this.body = ' + JSON.stringify(this.body, null, 2));
                                        }

                                        keys = Object.keys(this.body);


                                        parameters = keys.map(function (name) {
                                            return name + '=' + encodeURIComponent(_this.body[name]);
                                        });

                                        if (this.chatty) {
                                            this.log.debug('keys = ' + keys);
                                            this.log.debug('parameters = ' + parameters);
                                        }
                                    }

                                    if (this.needsAuthentication && this.needsAuthentication === 'in-parameters') {
                                        parameters.push(this.resource.callAuthTokenName + '=' + encodeURIComponent(_environment.authToken));
                                    }

                                    if (this.parameters) {
                                        parameters = parametersToQueryString(this.parameters);
                                    }

                                    if (parameters.length > 0) {
                                        this.url += '?' + parameters.join('&');
                                    }
                                } else {
                                    if (this.chatty) {
                                        this.log.debug(prefix + ' - it\'s not a GET');
                                    }

                                    if (this.parameters) {
                                        if (this.chatty) {
                                            this.log.debug(prefix + ' - merging parameters');
                                        }

                                        parameters = parametersToQueryString(this.parameters);

                                        if (parameters.length > 0) {
                                            this.url += '?' + parameters.join('&');
                                        }
                                        // this.body = Object.assign(this.body, this.parameters);
                                    }

                                    if (this.method === 'post') {
                                        if (this.chatty) {
                                            this.log.debug(prefix + ' - it\'s a POST');
                                        }

                                        // If the URL includes the ID field for the resource collection, we need to remove
                                        // it before performing the POST.  Ie, we want something like
                                        //
                                        //    categories/{categoryId}/subcategories/{subcategoryId}
                                        //
                                        // to become
                                        //
                                        //    categories/{categoryId}/subcategories
                                        //

                                        this.url = this.url.replace(/\/{\w+}$/, '');
                                    }

                                    if (this.body) {
                                        this.body = JSON.stringify(this.body, null, 2);
                                    }
                                }

                                if (this.chatty) {
                                    this.log.debug(prefix + ' - checking if this is \'configuration\'');
                                }

                                if (!(this.resource.name !== 'configuration')) {
                                    _context.next = 60;
                                    break;
                                }

                                if (this.chatty) {
                                    this.log.debug(prefix + ' - it\'s not \'configuration\'');
                                }

                                _context.next = 55;
                                return configuration.substituteConfigurationItems(this.url);

                            case 55:
                                this.url = _context.sent;


                                if (this.environment.name !== 'localhost') {
                                    // In case the developer has specified something like "http://10.1.56.123" as the
                                    // configuration host, replace "localhost" with that.

                                    if (this.environment.host.match(/(\d+)\.(\d+)\.(\d+)\.(\d+)/) !== null) {
                                        this.url = this.url.replace(/http:\/\/localhost(:\d+)?/g, this.environment.host);
                                    }
                                }

                                if (/^\/\//.test(this.url)) {
                                    // No protocol has been specified.  Take it from the current window location.

                                    if (typeof window === 'undefined') {
                                        // Looks like we're running inside a unit test

                                        if (this.chatty) {
                                            this.log.debug(prefix + ' - window is undefined' + ' (presumably, we\'re running in a unit test); mocking it.');
                                        }

                                        window = { location: 'https://' };
                                    }

                                    if (/^https/.test(window.location)) {
                                        this.url = 'https:' + this.url;
                                    } else {
                                        this.url = 'http:' + this.url;
                                    }
                                }

                                // Clean up duplicate slashes that may have been introduced, making sure
                                // to fix the http:// afterwards.

                                this.url = this.url.replace(/\/\//g, '/').replace(/(https?:)\//, '$1//');

                                // Start the clock here, to avoid double-counting the time spent in getting
                                // the configuration on the first call to substituteConfigurationItems().

                                this.startTime = new Date();

                            case 60:

                                if (this.chatty) {
                                    this.log.debug(prefix + ' - final URL is "' + this.url + '"');
                                }

                                if (this.chatty) {
                                    this.log.debug(prefix + ' - constructing promise');
                                }

                                callHeaders = { 'Content-Type': 'application/json' };


                                if (this.callHeaders) {
                                    callHeaders = _extends({}, callHeaders, this.callHeaders);
                                }

                                _environment = this.environment;
                                authTokenName = this.resource.callAuthTokenName;


                                if (_environment === undefined) {
                                    this.log.error('Whoops(3) - environment is undefined; let Harry know it happened again!');

                                    debugger;
                                }

                                if (!(this.needsAuthentication && callHeaders[authTokenName] === undefined)) {
                                    _context.next = 76;
                                    break;
                                }

                                if (!_environment.authToken) {
                                    _context.next = 74;
                                    break;
                                }

                                token = _environment.authToken;


                                if (this.chatty) {
                                    this.log.debug(prefix + ' - adding header "' + authTokenName + '" with value "' + token + '"');
                                }

                                callHeaders[authTokenName] = token;
                                _context.next = 76;
                                break;

                            case 74:
                                error = prefix + ' - this resource requires authentication, ' + ('but the ' + authTokenName + ' field is not set!');
                                throw error;

                            case 76:

                                // NOTE: The following code has been commented out since we're rethinking our authentication
                                //       strategy.  It will probably be removed completely sometime soon. (2021-09-24)

                                // if (this.willAcceptJWT) {
                                //     const jwt = this.environment.JWT;
                                //
                                //     if (jwt) {
                                //         if (this.chatty) {
                                //             console.log(`Adding Authorization header with Bearer = "${jwt}"`);
                                //         }
                                //
                                //         callHeaders['Authorization'] = `Bearer ${jwt}`;
                                //     } else {
                                //         if (this.chatty) {
                                //             console.log(`We have a JWT, but won't send it because this.willAcceptJWT is false.`);
                                //         }
                                //     }
                                // }

                                if (this.chatty) {
                                    this.log.debug(prefix + ' - final callHeaders =', callHeaders);
                                }

                                this.checkForDuplicateHeaders(callHeaders);

                                this.finalCallHeaders = callHeaders;

                                if (!shortCircuit) {
                                    _context.next = 84;
                                    break;
                                }

                                // The caller, which is presumably a test case, has asked for the HTTP request to be short-circuited.
                                // So, we'll just return ourselves, to allow them to interrogate the final URL, headers, etc.

                                if (this.chatty) {
                                    this.log.debug(prefix + ' - the shortCircuit' + ' parameter was set to true, so I\'m returning myself to the caller, which was' + ' presumably a test case.');
                                }

                                return _context.abrupt('return', this);

                            case 84:
                                this.promise = new Promise(this.handlers.bind(this));

                                if (this.chatty) {
                                    this.log.debug(prefix + ' - returning', this.promise);
                                }

                                return _context.abrupt('return', this.promise);

                            case 87:
                                _context.next = 93;
                                break;

                            case 89:
                                _context.prev = 89;
                                _context.t0 = _context['catch'](44);

                                this.log.debug(prefix + ' - caught an exception ...', _context.t0);

                                return _context.abrupt('return', { code: 'SEND_CAUSED_AN_EXCEPTION', data: _context.t0.toString() });

                            case 93:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[44, 89]]);
            }));

            function send() {
                return _ref.apply(this, arguments);
            }

            return send;
        }()
    }, {
        key: 'checkForDuplicateHeaders',
        value: function checkForDuplicateHeaders(callHeaders) {
            // We want all of the individual header names

            var keys = Object.keys(callHeaders);

            // The names object will have keys for the lower-case version
            // of each individual call headers.  That object's keys will
            // be all of the different variations of the name.

            var names = {};

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var key = _step.value;

                    var lowercaseKey = key.toLowerCase();
                    var known = names[lowercaseKey];

                    if (known === undefined) {
                        names[lowercaseKey] = _defineProperty({}, key, true);
                    } else {
                        known[key] = true;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            for (var name in names) {
                var differentNames = Object.keys(names[name]);

                if (differentNames.length > 1) {
                    // This is a key name that appears more than once, in
                    // different cases, in the original set of headers.

                    this.log.scream('Resource("' + this.resource.name + '").' + this.method + '().send()' + ' - the headers include the following names that only differ in upper/lower case:' + (' ' + differentNames.join(', ')));
                }
            }
        }
    }, {
        key: 'notifyProgressUsing',
        value: function notifyProgressUsing(callback) {
            this.progressCallback = callback;
        }

        // Implementation details ...

    }, {
        key: 'checkParameterValues',
        value: function checkParameterValues(parameterValues) {
            var missing = [];

            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = Object.keys(this.resource.cacheParameters)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var parameter = _step2.value;

                    // If the parameter was not provided, or is empty, consider
                    // it missing.

                    this.value = parameterValues[parameter];

                    if (this.value === undefined || /^\s*$/.test(this.value)) {
                        missing.push(parameter);
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            if (missing.length > 0) {
                if (missing.length > 1 || missing[0] !== this.resource.lastIdField) {
                    var message = 'Resource("' + this.resource.name + '").' + this.method + '().checkParameterValues() ' + ('- please provide these cache parameters: "' + missing.join(', ') + '"');

                    this.log.scream(message);
                }
            }
        }
    }, {
        key: 'buildUrl',
        value: function buildUrl(values) {
            values = values || {};

            // If the route includes references to any parameters,
            // we insert them into the generated URL.

            var url = this.resource.path;

            if (url === undefined) {
                var message = 'Resource("' + this.resource.name + '").' + this.method + '().buildUrl()' + ' - it looks like you forgot to call route() (or baseUrl() + service())';

                this.log.scream(message);

                debugger;
            }

            var match = void 0;

            var PARAMETER = /\/(:([\w.]+)|{\s*([\w.]+)\s*})/;

            while ((match = url.match(PARAMETER)) !== null) {
                var name = match[2] || match[3];
                var pattern = new RegExp('{\\s*' + name + '\\s*}');
                var value = values[name];

                if (value === undefined || /^\s*$/.test(value)) {
                    // If this is the last ID field, simply remove the placeholder, because this
                    // means the user wants the entire resource collection (for a GET), or is
                    // adding to the collection (for a POST).
                    //
                    // Otherwise, complain.

                    if ((this.method === 'get' || this.method === 'post') && name === this.resource.lastIdField) {
                        url = url.replace(':' + name, '');
                        url = url.replace(pattern, '');
                    } else {
                        var prefix = this.callDetails() + '.buildUrl() - you';
                        var details = value === undefined ? ' did not provide a value' : ' provided an empty value';
                        var _message3 = prefix + details + (' for parameter "' + name + '"');

                        this.log.scream(_message3);
                    }
                } else {
                    // Substitute the value

                    var _value = values[name].toString();

                    // We do two replace()s, to cover both :NAME and {NAME}

                    url = url.replace(':' + name, _value);
                    url = url.replace(pattern, _value);
                }
            }

            // Otherwise, simply return the generated URL

            return url;
        }
    }, {
        key: 'findMockData',
        value: function findMockData(route, data, context) {
            if (!data) {
                return undefined;
            }

            // The keys in the mock data omit the host, to make them workable irrespective
            // of the environment, so remove the http[s]:// from the URL before attempting
            // to find it.

            var response = data[route];

            if (response) {
                return response;
            }

            // See if we have a matching wildcard

            var keys = Object.keys(data);

            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
                for (var _iterator3 = keys[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var key = _step3.value;

                    var pattern = key.replace(/\//g, '\\/').replace(/\*/g, '[^/]+');
                    var regex = new RegExp('^' + pattern);

                    if (route.match(regex)) {
                        this.log.debug('Resource("' + this.resource.name + '").' + this.method + '().findMockData()' + ' - "${key}" in ${context} data matches ${route}');

                        return data[key];
                    }
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                    }
                } finally {
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }

            return undefined;
        }
    }, {
        key: 'handlers',
        value: function handlers(resolve, reject) {
            // TODO: Add the ability to time out the call

            this.resolve = resolve;
            this.reject = reject;

            this.attempts = 0;

            if (this.chatty) {
                this.log.debug('Resource("' + this.resource.name + '").' + this.method + '().handlers() - url = "' + this.url + '"');
                this.log.debug('Resource("' + this.resource.name + '").' + this.method + '().handlers() - method = "' + this.method + '"');
                this.log.debug('Resource("' + this.resource.name + '").' + this.method + '().handlers() - data = "' + JSON.stringify(this.body) + '"');
            }

            // All requests and responses are JSON, unless the caller has provided something else

            if (this.chatty) {
                this.log.debug('Resource("' + this.resource.name + '").' + this.method + '().handlers() - finalCallHeaders =' + (' ' + JSON.stringify(this.finalCallHeaders)));
            }

            var options = {
                method: this.method,
                headers: this.finalCallHeaders
            };

            if (this.method !== 'get' && this.body) {
                options.body = this.body;
            }

            // Construct a new XMLHttpRequest.  We use the function provided
            // as a property because we may be running inside a Node app, in
            // which case XMLHttpRequest is being polyfilled.

            var request = new this.xmlHttpRequest();

            // Some flags to keep track of how far through the process
            // the request went.  We will try to use these to provide
            // better information to the caller in case of a failure.

            this.headersReceived = false;
            this.responseDataLoaded = false;
            this.requestComplete = false;

            this.request = request;

            request.onreadystatechange = stateChange.bind(this);
            request.onload = success.bind(this);
            request.onerror = failure.bind(this, request);

            request.addEventListener("progress", updateProgress.bind(this));

            if (this.chatty) {
                this.log.debug('Resource("' + this.resource.name + '").' + this.method + '()' + ('- about to call XMLHttpRequest.open() for "' + this.url + '"'));
            }

            sendRequest.bind(this)(request);

            function sendRequest(request) {
                var _this2 = this;

                var url = this.url;
                var idField = undefined;

                if (this.method === 'get') {
                    if (this.parameterValues !== undefined) {
                        var _idField = this.resource.lastIdField;

                        if (_idField && this.parameterValues[_idField] === undefined) {
                            // The URL includes an ID field, but the user has not
                            // provided a value for the last ID. We will assume
                            // they want the entire collection.  Simply drop the
                            // ID field off the URL.

                            var match = url.match(/^(.*)(\/({.*?}))?$/);

                            url = match[1];
                        }
                    }
                }

                // Commented out the line below to fix a CORS issue when BE APIs don't accept http calls. NOTE: we only use http for local dev testing.
                // url = url.replace(/^https?:/, '');

                // console.log('3p-resource verb.js after removing protocol, url =', url);

                request.open(this.method.toUpperCase(), url, true);

                var headerKeys = Object.keys(this.finalCallHeaders);

                headerKeys.forEach(function (key) {
                    if (_this2.chatty) {
                        _this2.log.debug('Resource("' + _this2.resource.name + '").' + _this2.method + '()' + (' - setting header \'' + key + '\' to \'' + _this2.finalCallHeaders[key] + '\''));
                    }

                    request.setRequestHeader(key, _this2.finalCallHeaders[key]);
                });

                if (this.profileCallInitiation || this.chatty) {
                    this.log.debug(this.callDetails() + ' calling service ...');
                    this.log.debug(this.callDetails() + ' XMLHttpRequest object =', request);
                }

                if (this.resource.environment) {
                    this.resource.environment.incrementPendingRequests();
                }

                request.send(this.body || null);
            }

            function updateProgress(e) {
                if (this.request.lengthComputable) {
                    this.percentageComplete = 100 * e.loaded / e.total;

                    if (this.progressCallback) {
                        this.progressCallback(this.percentageComplete);
                    }
                }
            }

            function stateChange() {
                if (this.request.readyState === this.xmlHttpRequest.HEADERS_RECEIVED) {
                    this.headersReceived = true;
                }

                if (this.request.readyState === this.xmlHttpRequest.LOADING) {
                    this.responseDataLoaded = true;
                }

                if (this.request.readyState === this.xmlHttpRequest.DONE) {
                    this.requestComplete = true;
                }

                this.status = this.request.status;
            }

            function success(event) {
                if (this.resource.environment) {
                    this.resource.configuration.environment.decrementPendingRequests();
                }

                if (this.chatty) {
                    this.log.debug('Resource("' + this.resource.name + '").' + this.method + '().success()' + (' - event is ' + JSON.stringify(event)));

                    this.log.debug('Resource("' + this.resource.name + '").' + this.method + '().success()' + (' - event.response is ' + request.response));
                }

                // If the request has been cancelled, just ignore the response

                if (this.cancelled) {
                    this.log.warn('Resource("' + this.resource.name + '").' + this.method + '().success()' + ' - ignoring the response, because the request was cancelled.');
                    return;
                }

                if (this.progressCallback) {
                    this.progressCallback(100);
                }

                // We need to handle both the structure returned by window.XMLHttpRequest (response) and
                // by the xmlhttprequest NPM module (responseText).

                var response = request.response || request.responseText;

                handleResponseData.bind(this)(response);
            }

            function handleResponseData(response) {
                this.logElapsedTime();

                // console.log('handleResponseData() - this =', this);

                var prefix = this.callDetails() + '.handleResponseData()';
                var message = undefined;
                var code = undefined;

                if (this.chatty) {
                    this.log.debug(prefix + ' - response is ' + JSON.stringify(response));
                }

                // Unless the user has called Verb.raw(), we assume the response is JSON

                var data = void 0;

                if (this.rawResponse) {
                    data = response;
                } else {
                    // All responses that come from 3P services are JSON, so parse it

                    try {
                        data = JSON.parse(response);

                        if (this.chatty) {
                            this.log.debug('Status is', this.status, 'Unpacked JSON response is', data);
                        }

                        // If this is an old service, the response data will be wrapped inside
                        // a container with a single property called 'd'.  Strip that away.

                        data = unwrapLegacyResponse(data);
                    } catch (e) {
                        this.log.error('this.status = ' + this.status);

                        if (this.status === 204) {
                            // This is OK. It's just a response with no data. Just return
                            // an empty string.

                            data = '';
                        } else if (200 <= this.status && this.status < 300) {
                            // It's a successful response, but presumably the body is not
                            // JSON.  Provide the data as is, but with a message that points
                            // out that the caller should be using Verb.raw().

                            code = 'UnexpectedNonJsonData';

                            message = prefix + ' - the call to "' + this.url + '" sent a valid response' + (' with status ' + this.status + ', but it doesn\'t look like JSON.  If this ') + ' is what you\'re expecting, you should include raw() in your call chain.';
                        } else {
                            if (message === undefined) {
                                code = 'UnexpectedNonJsonData';
                                message = prefix + ' - the call to "' + this.url + '" returned status ' + this.status;
                            }
                        }
                    }
                }

                // If a transformation has been provided for converting
                // the response into the form we want, call it.

                if (this.transformer) {
                    if (200 <= this.status && this.status < 300) {
                        data = this.transformer(data);
                    }
                }

                // If we are caching responses, store it

                if (this.resource.cachedResponses) {
                    var key = this.cacheKey(this.parameterValues);

                    this.resource.cachedResponses[key] = data;
                }

                this.body = undefined;

                // Finally, send the response back

                var resolution = { status: this.status };

                if (400 <= this.status && this.status < 500) {
                    // Add all of the key/value pairs from the
                    // response.

                    if (data) {
                        var keys = Object.keys(data);

                        var _iteratorNormalCompletion4 = true;
                        var _didIteratorError4 = false;
                        var _iteratorError4 = undefined;

                        try {
                            for (var _iterator4 = keys[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                                var _key = _step4.value;

                                resolution[_key] = data[_key];
                            }
                        } catch (err) {
                            _didIteratorError4 = true;
                            _iteratorError4 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                                    _iterator4.return();
                                }
                            } finally {
                                if (_didIteratorError4) {
                                    throw _iteratorError4;
                                }
                            }
                        }
                    } else {
                        this.log.scream(prefix + ' - status = ' + this.status + ' referencing ' + this.url + ',' + (' and we have no data.\nDoes the application name \'' + this.application + '\'') + ' that you provided match the host application?');
                        // this.log.scream(`${prefix} - status = ${this.status} referencing ${this.url},` +
                        //     ` and we have no data.\nDoes the application name` +
                        //     ' you provided match the host application?');

                        resolution.code = 'UnexpectedResponseContent';
                        resolution.message = 'The response was not JSON';
                    }
                } else if (200 <= this.status && this.status < 300) {
                    resolution.data = this.sortResponse(data);

                    if (message) {
                        this.log.error(message);
                        resolution.message = message;
                    }
                }

                if (this.chatty) {
                    this.log.debug('Resource("' + this.resource.name + '").' + this.method + '().handleResponseData()' + ' - resolving with', resolution);
                }

                if (data && (this.status < 200 || this.status >= 300)) {
                    // Rename the fields

                    if (data.Code) {
                        resolution.code = data.Code;
                    }

                    if (data.Message) {
                        resolution.message = data.Message;
                    }

                    this.log.error(prefix + ' - the server returned for URL "' + this.url + '"' + (' with error status ' + resolution.status + ', ') + (' Code = "' + resolution.code + '" and Message = "' + resolution.message + '"'));
                }

                this.resolve(this.result(resolution));
            }

            function unwrapLegacyResponse(data) {
                if (data['d']) {
                    data = data['d'];
                }

                return data;
            }

            /*
                    function isErrorResponse(data) {
                        // We check for both legacy and current response error formats
            
                        return (hasLegacyErrorFormat.bind(this)(data) || hasErrorFormat.bind(this)(data));
                    }
            
                    function hasLegacyErrorFormat(data) {
                        if (data['IsError']) {
                            if (this.errorHandler) {
                                this.errorHandler(error, response, data);
            
                                return true;
                            }
                            else {
                                let message = `Resource("${this.resource.name}").${this.method}().responseHandler()` +
                                    ` - IsError is true;`;
            
                                message += ` ResponseCode = ${data['ResponseCode']}`;
                                message += ` ResponseMessage = "${data['ResponseMessage']}"\n`;
            
                                this.log.scream(message);
            
                                this.body = undefined;
            
                                let error = 'IsError = true';
            
                                if (data['ResponseCode']) {
                                    error += ` ResponseCode = ${data['ResponseCode']}`;
                                }
            
                                if (data['ResponseMessage']) {
                                    error += ` ResponseMessage = ${data['ResponseMessage']}`;
                                }
            
                                // this.log.debug(`Resource("${this.resource.name}").${this.method}().handleResponseData()` +
                                //     ` - resolving with {message: "${error}", status: ${status}}`);
            
                                this.resolve(this.result({message: error, status: this.status}));
            
                                return true;
                            }
                        }
            
                        return false;
                    }
            
                    function hasErrorFormat(data) {
                        const message = data['message'] || data['Message']; // TODO We should standardise upper/lower case!
            
                        this.body = undefined;
            
                        if (message) {
                            if (this.errorHandler) {
                                this.errorHandler(error, response, data);
            
                                return true;
                            } else {
                                this.body = undefined;
            
                                this.log.debug(`Resource("${this.resource.name}").${this.method}().handleResponseData()` +
                                    ` - resolving with { message: "${message}", status: ${this.status}}`);
            
                                this.resolve(this.result({ message: message, status: this.status }));
            
                                return true;
                            }
                        }
            
                        return false;
                    }
            */

            function failure(request, error) {
                this.resource.configuration.environment.decrementPendingRequests();

                this.logElapsedTime();

                var prefix = this.callDetails();

                this.log.debug(prefix + ' - error = ' + JSON.stringify(error));

                // If the request has been cancelled, just ignore the response

                if (this.cancelled) {
                    this.log.warn(prefix + ' - ignoring the failure, because the request was cancelled.');
                    return;
                }

                if ((this.attempts += 1) < this.maxRetries) {
                    if (this.chatty) {
                        this.log.debug(prefix + ' - retrying; attempts so far = ' + this.attempts);
                    }

                    setTimeout(retry.bind(this, request), 250);
                } else {
                    this.body = undefined;

                    if (this.errorHandler) {
                        this.errorHandler(error, data);
                    } else {
                        this.logElapsedTime();
                        this.body = undefined;

                        var message = void 0;

                        if (!this.headersReceived || !this.responseDataLoaded) {
                            // It looks like the request never made it out to the server. The
                            // most likely cases are that we're not connected to the internet
                            // or the URL doesn't point to an actual host, causing the OPTIONS
                            // to fail.

                            message = prefix + ' - The XMLHttpRequest didn\'t run through the full execution cycle.\n' + '  This could be because we have no internet connection, the server is offline, or the URL\n' + ('  "' + this.url + '" is incorrect in some way\n') + '  (eg, it\'s malformed or the server does not exist).';
                        } else {
                            message = prefix + ' - resolving with {message: "' + error + '"}';
                        }

                        this.log.error(message);

                        this.resolve(this.result({ message: error, status: this.status }));
                    }
                }
            }

            function retry(request) {
                if (this.chatty) {
                    this.log.debug('Resource("' + this.resource.name + '").' + this.method + '().call().responseHandler().retry()' + ' - calling service again');
                }

                sendRequest.bind(this)(request);
            }
        }
    }, {
        key: 'sortResponse',
        value: function sortResponse(items) {
            if (this.ordering && Array.isArray(items)) {
                var sorter = new _multiSorter2.default(this.ordering);

                return sorter.sort(items);
            } else {
                return items;
            }
        }
    }, {
        key: 'logElapsedTime',
        value: function logElapsedTime() {
            if (!this.profileCallDuration) {
                return;
            }

            var elapsedMilliseconds = new Date().getTime() - this.startTime.getTime();
            var seconds = (elapsedMilliseconds - elapsedMilliseconds) / 1000;

            var ms = '' + elapsedMilliseconds % 1000;

            while (ms.length < 3) {
                ms = '0' + ms;
            }

            var details = this.callDetails();

            if (this.profileCallDuration) {
                this.log.debug(details + ' took ' + seconds + '.' + ms + 's');
            }
        }
    }, {
        key: 'cacheKey',
        value: function cacheKey(parameterValues) {
            this.checkParameterValues(parameterValues);

            return this.resource.cacheKey(parameterValues);
        }

        // Private implementation details

    }, {
        key: 'logElapsedTime',
        value: function logElapsedTime() {
            if (!this.profileCallDuration) {
                return;
            }

            var elapsedMilliseconds = new Date().getTime() - this.startTime.getTime();
            var seconds = (elapsedMilliseconds - elapsedMilliseconds % 1000) / 1000;

            var ms = '' + elapsedMilliseconds % 1000;

            while (ms.length < 3) {
                ms = '0' + ms;
            }

            var details = this.callDetails();

            if (this.profileCallDuration) {
                this.log.debug(details + ' took ' + seconds + '.' + ms + 's');
            }
        }
    }, {
        key: 'callDetails',
        value: function callDetails() {
            var callDetails = 'Resource("' + this.resource.name + '").' + this.method + '(';

            if (this.parameterValues) {
                var parametersText = void 0;

                try {
                    parametersText = '' + JSON.stringify(JSON.decycle(this.parameterValues));
                } catch (e) {
                    this.log.error(e);

                    parametersText = '<circular>';
                }

                callDetails += parametersText;
            }

            callDetails += ')';

            if (this.body) {
                var bodyText = void 0;

                try {
                    bodyText = JSON.stringify(JSON.decycle(this.body)).replace(/\\n/g, '').replace(/\s+/g, ' ').replace(/\\"/g, '\'');
                } catch (e) {
                    this.log.error(e);

                    bodyText = '<circular>';
                }

                callDetails += '.withBody(' + bodyText + ')';
            }

            return callDetails;
        }
    }]);

    return Verb;
}();

module.exports = Verb;


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/resource/lib/verb.js
// module id = 619
// module chunks = 4